<template>
  <div class="adput-creation-add">
    <up-preview
      class="adput-creation-add__preview"
      width="90%"
      v-model="preview.visible"
      :initial-index="preview.activeIndex"
      :active-index.sync="preview.activeIndex"
      :data="preview.data"
      :autoplay="false"
    >
      <template slot-scope="{ item }">
        <div class="adput-creation-add__preview-image-wrap">
          <video
            v-if="item.material.endsWith('.mp4')"
            class="adput-creation-add__preview-image"
            :src="item.material"
            controls
          ></video>
          <img v-else class="adput-creation-add__preview-image" :src="item.material" />
        </div>
      </template>
    </up-preview>

    <div class="panel-header">
      <h3 class="panel-header__title">创意管理</h3>
      <span class="panel-header__subtitle">CREATION MANAGEMENT</span>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">创意管理</h3>
      <up-form
        class="panel-content__form"
        :model="form"
        :rules="rules"
        ref="form"
        label-width="150px"
        v-loading="loading"
        element-loading-text="加载中..."
      >
        <up-form-item-select
          v-if="platform === 'agency'"
          prop="aduser_id"
          label="所属广告主"
          v-model="form.aduser_id"
          :disabled="['edit', 'view'].includes(type)"
          :data="adUsers"
          filterable
          placeholder="请选择所属广告主"
          @up:select:change="getAdGroupsByAdUserId"
        ></up-form-item-select>
        <up-form-item-select
          prop="order_id"
          label="所属广告组"
          filterable
          v-model="form.order_id"
          :disabled="['edit', 'view'].includes(type)"
          :data="adGroups"
          :key-value="['order_name', 'id']"
          placeholder="请选择所属广告组"
          @up:select:change="getPlansByAdGroupId"
        ></up-form-item-select>
        <up-form-item-select
          prop="ad_id"
          label="所属计划"
          v-model="form.ad_id"
          :disabled="['edit', 'view'].includes(type)"
          :data="plans"
          :key-value="['ad_name', 'id']"
          placeholder="请选择所属计划"
          filterable
          @up:select:change="handleAdPlanChange"
        ></up-form-item-select>
        <up-form-item-input
          prop="creative_name"
          class="w364"
          label="创意名称"
          v-model="form.creative_name"
          placeholder="请输入创意名称"
        ></up-form-item-input>
        <div class="panel-content__group">
          <h4 class="panel-content__group-title">落地页：</h4>
          <div class="panel-content__group-content">

            <!-- deeplink -->
            <up-form-item-input
              prop="deeplink"
              class="w364"
              label="deeplink"
              v-model="form.deeplink"
              v-if="isApp"
              placeholder="请输入deeplink"
            >
              <template slot="label">
                deeplink
                <up-tooltip effect="light" placement="right">
                  <div slot="content">
                    若用户已安装目标APP，用户点击广告后将直接打
                    <br />开APP或跳转到APP指定页面，若您的广告不需此
                    <br />功能请不要填写此项，以免造成跳转异常
                  </div>
                  <i class="icon iconfont icon-iconfontquestion"></i>
                </up-tooltip>
              </template>
            </up-form-item-input>
            <!-- 落地页推广 -->
            <!-- 落地页转化监测移除 -->
            <!-- <up-form-item
              v-if="currentGroupJumpType === 1 && false"
              prop="conversion_monitor_type"
              label="落地页转化监测"
            >
              <template slot="label">
                落地页转化监测
                <up-tooltip effect="light" placement="right">
                  <div slot="content">
                    选择JS监测，需要根据Infinities 官网JS对接流程添加监
                    <br />测代码，然后将添加完监测代码的链接输入到落地
                    <br />页选项
                  </div>
                  <i class="icon iconfont icon-iconfontquestion"></i>
                </up-tooltip>
              </template>
              <up-radio-group v-model="form.conversion_monitor_type" :data="conversionMonitorTypes"></up-radio-group>
              <a
                v-show="form.conversion_monitor_type === '1'"
                class="panel-content__table-link"
                style="margin-left: 20px;"
                href="http://www.adjuhui.cn/html/documentCenter.html#JSdocking1"
                target="_blank"
              >查看JS监测对接流程</a>
            </up-form-item> -->
            <up-form-item class="w364" prop="ad_url" label="落地页URL" v-if="!(isIos && currentGroupJumpType === 2)">
              <template slot="label">
                落地页URL
                <up-tooltip effect="light" placement="right">
                  <div slot="content">
                    请输入直接访问落地页的地址，建议不要输入
                    <br />deeplink链接
                  </div>
                  <i class="icon iconfont icon-iconfontquestion"></i>
                </up-tooltip>
              </template>
              <up-input v-model="form.ad_url" placeholder="请输入落地页URL" @change="handleAdUrlChange"></up-input>
              <up-tooltip effect="light" placement="right">
                <div slot="content">
                  系统会在链接地址后添加安全无害的效果统计参数，
                  <br />请点击验证添加后的地址有效。
                </div>
                <up-button class="ml5 mr10" type="primary" @click="openAdUrl">预览</up-button>
              </up-tooltip>
              <template>
                <span
                  v-if="adUrlTxt && !checking"
                  class="adput-creation-add__landpage-message"
                  :class="`${validAdUrl ?'is-correct' : 'is-wrong' }`"
                >{{ `${validAdUrl ? '√' : '×'} ${adUrlTxt}` }}</span>
                <i v-if="checking" class="el-icon el-icon-loading"></i>
              </template>
            </up-form-item>
            <up-form-item prop="landing_page_pic">
              <div class="adput-creation-add__landpage">
                <up-upload
                  class="adput-creation-add__landpage-upload"
                  action="whatever"
                  ref="upload"
                  :file-list="fileList"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="handleOnChangeAdUrl"
                  :disabled="disabledAdUrl"
                >
                  <up-button
                    size="small"
                    type="primary"
                    :style="{ 'cursor': disabledAdUrl ? 'not-allowed' : 'pointer' }"
                    :disabled="disabledAdUrl"
                  >
                    {{ form.landing_page_pic ? '重新上传落地页长截图' : '上传落地页长截图' }}
                    <i class="el-icon-upload el-icon--right"></i>
                  </up-button>
                </up-upload>
                <div class="adput-creation-add__landpage-tip">
                  <up-tooltip effect="light" placement="right">
                    <div slot="content">
                      如链接为直接下载类链接，需上传应用内截图；
                      <br />如果是H5页面，需要提供落地页长截图。
                    </div>
                    <i class="icon iconfont icon-iconfontquestion"></i>
                  </up-tooltip>
                  <span class="item">格式：PNG或JPG，大小：小于150KB</span>
                </div>
                <div class="adput-creation-add__landpage-pic" v-show="form.landing_page_pic">
                  <img :src="form.landing_page_pic" />
                </div>
              </div>
            </up-form-item>
            <!-- 应用下载 -->
            <up-form-item-input
              v-if="currentGroupJumpType === 2 && isAndroid"
              prop="apk_name"
              class="w364"
              label="包名"
              v-model="form.apk_name"
              placeholder="请输入包名"
            >
            <template slot="label">
                包名
                <up-tooltip effect="light" placement="right">
                  <div slot="content">
                    请联系客户侧技术人员获取
                    <br />同一App在不同的应用商店可能使用的不同包名
                  </div>
                  <i class="icon iconfont icon-iconfontquestion"></i>
                </up-tooltip>
              </template>
            </up-form-item-input>
            <up-form-item-input
              v-if="currentGroupJumpType === 2 && isIos"
              prop="apk_name"
              class="w364"
              label="AppID"
              v-model="form.apk_name"
              placeholder="请输入AppID"
              :rules="rules.app_id"
            >
            <template slot="label">
                AppID
                <up-tooltip effect="light" placement="right">
                  <div slot="content">
                    由于无需访问落地页，若客户有监测需求请用异步监测
                    <br /> - 如何获取App ID：
                    <p>
                      方法1：通过七麦（
                      <el-link href="https://www.qimai.cn/" type="primary" :underline="false" target="_blank">https://www.qimai.cn/</el-link>
                      ）搜索应用查看应用信息中的App ID
                    </p>
                    <p>
                      方法2：在AppStore（
                      <el-link href="https://www.apple.com.cn/ios/app-store/" type="primary" :underline="false" target="_blank">https://www.apple.com.cn/ios/app-store/</el-link>
                      ）搜索应用打开后通过URL尾部中的纯数字查看
                    </p>
                  </div>
                  <i class="icon iconfont icon-iconfontquestion"></i>
                </up-tooltip>
              </template>
            </up-form-item-input>
            <up-form-item-radio
             v-if="currentGroupJumpType === 2 && planPortType === '2'"
              label="优先从应用商店下载"
              :data="firstAppStore"
              v-model="form.first_app_store"
              prop="first_app_store"
            ></up-form-item-radio>
            <up-form-item-radio
              prop="monitor_type"
              label="监控类型"
              v-model="form.monitor_type"
              :data="monitorTypes"
            ></up-form-item-radio>
            <template v-if="form.monitor_type !== '0'">
              <up-form-item label="第三方曝光监测(异步)" class="adput-creation-add__monitor">
                <el-form-item
                  v-for="(item, index) in form.monitor_pv_urls"
                  :key="item.key"
                  :prop="'monitor_pv_urls.'+index+'.value'"
                  class="w364"
                  :rules="[{ required: true, validator: validateUrls(true), trigger: 'blur' }]"
                >
                  <el-input class="mr10" v-model="item.value"></el-input>
                  <el-button  @click.prevent="handleAddMonitor('monitor_pv_urls')">添加</el-button>
                  <el-button v-if="form.monitor_pv_urls.length > 1" @click="handleRemoveMonitor(item, 'monitor_pv_urls')">删除</el-button>
                </el-form-item>
              </up-form-item>
              <up-form-item label="第三方点击监测(异步)" class="adput-creation-add__monitor">
                <el-form-item
                  v-for="(item, index) in form.monitor_urls"
                  :key="item.key"
                  :prop="'monitor_urls.'+index+'.value'"
                  class="w364"
                  :rules="[{ required: true, validator: validateUrls(false), trigger: 'blur' }]"
                >
                  <el-input class="mr10" v-model="item.value"></el-input>
                  <el-button  @click.prevent="handleAddMonitor('monitor_urls')">添加</el-button>
                  <el-button v-if="form.monitor_urls.length > 1" @click="handleRemoveMonitor(item, 'monitor_urls')">删除</el-button>
                </el-form-item>
              </up-form-item>
            </template>
          </div>
        </div>
        <div class="panel-content__group">
          <h4 class="panel-content__group-title">素材：</h4>
          <div class="panel-content__group-content">
            <!-- , { name: '视频', value: '2' } -->
            <up-form-item-radio
              v-if="!isMotivate"
              prop="create_type"
              label="素材类型"
              v-model="form.create_type"
              :data="[{ name: '图片', value: '1' }]"
            ></up-form-item-radio>
            <!-- <template v-if="isFlow || isMotivate"> -->
            <template>
              <up-form-item-input class="w364" prop="title" label="广告标题" v-model="form.title"></up-form-item-input>
              <up-form-item-input
                class="w364"
                prop="spread_name"
                label="推广名称"
                v-model="form.spread_name"
              ></up-form-item-input>
            </template>
            <up-form-item label="素材上传" prop="filenames" :show-message="false">
              <div
                class="adput-creation-add__upload-tip"
              >{{ form.information === '2' ? '组图素材必须上传三张图片' : '为了让素材更好的适配不同宽高比的广告位，建议您上传如下多个不同比例的素材，系统会根据广告位宽高比适配并下发最合适比例的创意' }}</div>
              <up-table
                class="adput-creation-add__table"
                border
                align="center"
                :page="page"
                :width-columns="{ no: '80px', material: '160px', material_size: '160px', upload_status: '100px' }"
                :slot-contents="['material', 'material_size', 'material_name', 'upload_status']"
                @cell-click="handleCellClick"
              >
                <template slot="material:content" slot-scope="{ row }">
                  <template v-if="row.material">
                    <video v-if="row.material.endsWith('.mp4')" src="row.material" controls></video>
                    <img v-else class="adput-creation-add__table-material" :src="row.cut_path" />
                  </template>

                  <img
                    v-else
                    class="adput-creation-add__table-material"
                    :src="defaultMaterialImage"
                    alt
                  />
                </template>
                <template slot="material_size:content" slot-scope="{ row }">
                  <template v-if="isMotivate">
                    <div
                      class="adput-creation-add__table-material-size"
                    >{{ row.create_type === 1 ? '图片' : '视频' }}（素材类型）</div>
                    <div
                      class="adput-creation-add__table-material-size"
                    >{{ materialTypes[row.material_type] }}（素材内容）</div>
                  </template>
                  <div class="adput-creation-add__table-material-size">
                    {{ row.minimum_upload_size }}
                    <span
                      :class="{ 'is-recommend': row.is_recommend === 1 }"
                    >（{{ row.is_recommend === 1 ? '推荐尺寸' : '选传尺寸' }}）</span>
                  </div>
                  <div class="adput-creation-add__table-material-size" v-if="row.material_size">
                    {{ row.material_size }}
                    <span>（原尺寸）</span>
                  </div>
                  <p class="adput-creation-add__table-remark">{{ row.remark }}</p>
                </template>
                <template slot="material_name:content" slot-scope="{ row }">
                  <a
                    v-if="row.material"
                    :href="row.material"
                    class="panel-content__table-link"
                    target="_blank"
                  >{{ row.material }}</a>
                  <span>-</span>
                </template>
                <template
                  slot="upload_status:content"
                  slot-scope="{ row }"
                >{{ row.material ? '已上传' : '待上传' }}</template>
                <template slot="up:operate">
                  <up-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                      <up-upload
                        class="adput-creation-add__replace"
                        action="whatever"
                        :auto-upload="false"
                        :show-file-list="false"
                        :on-change="(file, fileList) => handleOnChange(file, fileList, scope)"
                        :disabled="uploading[scope.$index]"
                      >
                        <up-button size="small" type="primary">
                          {{ scope.row.material ? '替换' : '上传' }}
                          <i v-if="uploading[scope.$index]" class="el-icon el-icon-loading"></i>
                        </up-button>
                      </up-upload>
                      <up-popover
                        v-if="scope.row.material"
                        placement="top"
                        width="160"
                        v-model="visibles[scope.$index]"
                        hasFooter
                        @up:confirm="handleOnRemove(scope)"
                      >
                        <p>确定要删除该素材吗？</p>
                        <up-button
                          slot="reference"
                          size="small"
                          class="is-remove ml5"
                          type="primary"
                        >
                          删除
                          <i v-if="removing[scope.$index]" class="el-icon el-icon-loading"></i>
                        </up-button>
                      </up-popover>
                    </template>
                  </up-table-column>
                </template>
              </up-table>
            </up-form-item>
                    <!-- 开屏交互引导文案  -->
        <up-form-item-input v-if="isOpenScreen" label="开屏引导文案" class="w364" placeholder="请输入开屏引导文案, 不超过14字" prop="open_screen_guide_text" v-model="form.open_screen_guide_text"></up-form-item-input>
          </div>
        </div>
        <div class="panel-content__btn-group">
          <div class="panel-content__btn" v-if="type !== 'view'">
            <up-button size="large" type="primary" @click="submitForm('form')">{{ btnText('提交') }}</up-button>
          </div>
          <div class="panel-content__btn">
            <up-button size="large" class="is-cancel" @click="$router.go(-1)">取消</up-button>
          </div>
        </div>
      </up-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { groupBy } from '@/global/util/util'
import bus from '@/global/util/bus'

const h = bus.$createElement
const REGEXP_WEBSITE_URL = /^https?:\/\//

export default {
  name: 'creation-add',
  data() {
    const validateCreativeName = async (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入创意名称'))
      } else if (value.length > 50) {
        callback(new Error('创意名称不能超过50个字符'))
      } else {
        const [, res] = await this['creation/validateCreativeName']({ platform: this.platform, value })
        if (
          res.data.status === 1 &&
          (
            ['add', 'copy'].includes(this.type) ||
            (this.type === 'edit' && this.originalCreativeName !== value)
          )
        ) {
          callback(new Error('创意名称已经存在'))
        } else {
          callback()
        }
      }
    }

    const validateConversionMonitorType = async (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择落地页转化监测'))
      } else if (this.form.ad_url) { // 已经输入了落地页URL
        this.$refs.form.validateField('ad_url')
      } else {
        callback()
      }
    }

    const validateAdUrl = async (rule, value, callback) => {
      this.validAdUrl = false
      this.hasCheckedAdUrl = this.lastAdUrl === value
      if (value === '') {
        callback(new Error('请输入落地页URL'))
      } else if (!REGEXP_WEBSITE_URL.test(value)) {
        callback(new Error('落地页URL必须输入以 http 或 https 开头'))
      } else {
        if (this.form.conversion_monitor_type === '') { // 未选择落地页转化监测
          this.$refs.form.validateField('conversion_monitor_type')
        } else {
          if (!this.hasCheckedAdUrl) await this.checkAdUrl()
          callback()
          // const valid = await this.checkAdUrl()
          // if (!valid) {
          //   callback(new Error('落地页URL异常无法解析，请重新输入'))
          // } else {
          //   callback()
          // }
        }
      }
    }

    const validateUrls = this.validateUrls = (isPv) => (rule, value, callback) => {
      if (this.form.monitor_type === '0' || (value && REGEXP_WEBSITE_URL.test(value))) callback()
      const text = isPv ? '曝光' : '点击'
      const type = isPv ? 'monitor_urls' : 'monitor_pv_urls'
      if (value === '') {
        const isEmpty = this.form[type].some(item => item.value !== '')
        if (!isEmpty) {
          callback(new Error(`请输入第三方${text}监测`))
        } else {
          callback()
        }
      } else if (!REGEXP_WEBSITE_URL.test(value)) {
        callback(new Error(`第三方${text}必须以 http 或 https 开头`))
      }
    }

    // const validateLandingPagePic = (rule, value, callback) => {
    //   console.log(value, this.disabledAdUrl)
    //   if (!this.disabledAdUrl) {
    //     if (value === '') {
    //       callback(new Error('请上传落地页长截图'))
    //     } else {
    //       callback()
    //     }
    //   } else {
    //     callback()
    //   }
    // }

    const validateApkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入包名'))
      } else if (value.length > 100) {
        callback(new Error('包名超过不能100个字符'))
      } else {
        const regx = /^([a-zA-Z_][a-zA-Z0-9_]*)+([.][a-zA-Z_][a-zA-Z0-9_]*)+$/
        if (!regx.test(value)) {
          callback(new Error('格式须符合 xx.xx.xx或 xx.xx.xx.xx。包名每段需由字母开头'))
        } else {
          callback()
        }
      }
    }
    const validateAppID = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入AppID'))
      } else if (!/^[0-9]*[1-9][0-9]*$/.test(value)) {
        callback(new Error('AppID需为数字'))
      } else {
        callback()
      }
    }
    const validateFilenames = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('请上传素材'))
      } else if (this.isFlow) {
        if (this.form.information === '2' && value.length !== 3) {
          callback(new Error('组图素材必须上传三张图片'))
        } if (['1', '3'].includes(this.form.information) && value.length < 1) {
          callback(new Error(`${this.form.information === '1' ? '小图' : '大图'}素材至少上传一张图片！`))
        } else {
          callback()
        }
      } else if (this.isMotivate) { // 激励视频
        const groupedMtData = groupBy(value, 'material_type')

        if (Object.keys(groupedMtData).length > 0) {
          if (!groupedMtData[1]) { // 图片
            callback(new Error('必须上传一个主素材'))
          } else if (!groupedMtData[2]) {
            callback(new Error('必须上传一张封面图片'))
          } if (!groupedMtData[3]) {
            callback(new Error('必须上传一张icon图片'))
          } else {
            callback()
          }
        } else {
          callback(new Error('主素材、封面、icon 必须各上传一张'))
        }

        // if (groupedData) {

        // }
        callback(new Error('kkkkkkk'))
      } else {
        callback()
      }
    }

    this.defaultMaterialImage = require('../../../assets/default.png')

    this.materialTypes = ['', '主素材', '封面', 'icon']

    return {
      platform: '',
      id: '',
      type: '',
      loading: false,
      originalCreativeName: '',
      isApp: false, // 是否是移动端
      adUrlTxt: '', // 落地页检测结果
      checking: false,
      validAdUrl: false, // 落地页是否合法
      isAdUrlPicExist: false, // 落地页图片是否存在
      hasCheckedAdUrl: false, // 是否已经验证过了
      lastAdUrl: '', // 上一个 url
      currentGroupJumpType: '',
      planPortType: '', // 计划类型 ios/Android
      form: {
        aduser_id: '',
        order_id: '',
        ad_id: '',
        creative_name: '',
        conversion_monitor_type: '',
        ad_url: '',
        landing_page_pic: '',
        apk_name: '',
        first_app_store: '',
        deeplink: '',
        monitor_type: '',
        create_type: '1',
        information: '',
        title: '',
        spread_name: '',
        filenames: [],
        open_screen_guide_text: '', // 根据跳转行为展示默认文字
        monitor_pv_urls: [{
          key: Date.now(),
          value: ''
        }], // 曝光监测
        monitor_urls: [{
          key: Date.now(),
          value: ''
        }]
      },
      rules: {
        aduser_id: [{ required: true, message: '请选择所属广告主', trigger: 'change' }],
        order_id: [{ required: true, message: '请选择所属广告组', trigger: 'change' }],
        ad_id: [{ required: true, message: '请选择所属计划', trigger: 'change' }],
        creative_name: [{ required: true, validator: validateCreativeName, trigger: 'blur' }],
        conversion_monitor_type: [{ required: true, validator: validateConversionMonitorType, trigger: 'change' }],
        ad_url: [{ required: true, validator: validateAdUrl, trigger: 'blur' }],
        // landing_page_pic: [{ required: true, validator: validateLandingPagePic, trigger: 'blur' }],
        apk_name: [
          { required: true, validator: validateApkName, trigger: 'blur' }
        ],
        app_id: [
          { required: true, validator: validateAppID, trigger: 'blur' }
        ],
        first_app_store: [{ required: true, message: '请选择是否优先从应用商店下载', trigger: 'change' }],
        // deeplink: [{ required: true, message: '请输入deeplink', trigger: 'blur' }],
        monitor_type: [{ required: true, message: '请选择监控类型', trigger: 'change' }],
        monitor_pv_urls: [{ validator: validateUrls(true), trigger: 'blur' }],
        monitor_urls: [{ validator: validateUrls(false), trigger: 'blur' }],
        create_type: [{ required: true, message: '请选择素材类型', trigger: 'change' }],
        // information: [{ required: true, message: '请选择信息流展示样式', trigger: 'change' }],
        title: [{ required: false, message: '请输入广告标题', trigger: 'blur' }, { max: 50, message: '广告标题不能超过50个字符', trigger: 'blur' }],
        spread_name: [{ max: 14, message: '推广名称不能超过14个字符', trigger: 'blur' }],
        filenames: [{ type: 'array', required: true, validator: validateFilenames, trigger: 'change' }],
        open_screen_guide_text: [
          { required: true, message: '请输入开屏交互引导文案', trigger: 'blur' },
          { max: 14, message: '引导文案不能超过14个字', trigger: 'blur' }
        ]
      },
      fileList: [],
      adUsers: [],
      adGroups: [],
      plans: [],
      firstAppStore: [],
      conversionMonitorTypes: [],
      monitorTypes: [],
      // informations: [],
      materialFileList: [],
      page: new this.$page({
        header: { no: '编号', material: '素材', material_size: '素材大小', material_name: '素材地址', upload_status: '上传状态' }
        // header: { preview: '素材', path: '素材名称', size: '素材尺寸', match: '是否匹配' }
      }),
      visibles: [],
      removing: [],
      uploading: [],
      submiting: false,
      submited: false,
      verifying: false,
      preview: {
        data: [],
        activeIndex: -1,
        visible: false
      },
      isMotivate: false, // place_attribute === '11' 是否是激励视频
      isOpenScreen: false // 是否开屏广告
    }
  },
  computed: {
    ...mapGetters({
      userid: 'login/userid'
    }),
    disabledAdUrl() {
      return !this.validAdUrl || this.isAdUrlPicExist
    },
    btnText() {
      return function (text) {
        return this.submiting ? `${text}中...` : this.submited ? `已${text}` : text
      }
    },
    isFlow() {
      return ['1', '2', '3'].includes(this.form.information)
    },
    isAndroid() {
      return this.planPortType === '2'
    },
    isIos() {
      return this.planPortType === '1'
    }
  },
  methods: {
    ...mapActions([
      'creation/validateCreativeName',
      'creation/getAdUsers',
      'creation/getAdGroupsByAdUserId',
      'creation/getPlansByAdGroupId',
      'creation/checkAdUrl',
      'creation/uploadPicture',
      'creation/uploadVideo',
      'creation/uploadMaterialCut',
      'creation/getMaterialSizes',
      'creation/handleOnRemove',
      'creation/submitForm',
      'creation/getItems',
      'creation/created',
      'creation/getFirstAppStoreOptions'
    ]),
    async getAdUsers() {
      const [err, res] = await this['creation/getAdUsers']({ platform: this.platform })
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取广告主列表失败！')
      else {
        this.adUsers = res.code === 1 ? res.data : []
      }
    },
    async getAdGroupsByAdUserId(value, fromCreated) {
      if (this.type === 'add' || (this.type === 'copy' && !fromCreated)) {
        this.form.order_id = ''
        this.form.ad_id = ''
        this.isOpenScreen = false
        this.$nextTick(_ => {
          this.$refs.form.clearValidate(['order_id', 'ad_id'])
        })
      }
      const [err, res] = await this['creation/getAdGroupsByAdUserId']({ platform: this.platform, value }) // 广告主平台不需要 value 参数
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取广告组列表失败！')
      else {
        this.adGroups = res.code === 1 ? res.data : []
      }
    },
    async getPlansByAdGroupId(value, fromCreated) {
      if (this.type === 'add' || (this.type === 'copy' && !fromCreated)) {
        this.form.ad_id = ''
        this.isOpenScreen = false
        this.$nextTick(_ => {
          this.$refs.form.clearValidate('ad_id')
        })
      }
      const [err, res] = await this['creation/getPlansByAdGroupId']({ platform: this.platform, value })
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取计划列表失败！')
      else {
        this.plans = res.code === 1 ? res.data : []
        this.currentGroupJumpType = (this.adGroups.find(v => v.id === value) || {}).jump_type
        if (this.currentGroupJumpType === 2 && this.firstAppStore.length < 1) {
          this._getFirstAppStoreOptions()
        }

        // 处理跳转类型 开屏引导默认值
        this.handleChangeJumpType()
      }
    },
    // 获取是否应用商店下载
    async _getFirstAppStoreOptions() {
      const result = await this['creation/getFirstAppStoreOptions']()
      this.firstAppStore = result.data
      if (!this.form.first_app_store) {
        this.form.first_app_store = result.data[0].value
      }
    },
    async handleAdPlanChange(value) {
      const { information, place_attribute, port_type: portType } = this.plans.find(v => v.id === value) || {} /* eslint-disable-line */
      this.form.information = information
      this.planPortType = portType
      this.isApp = ['1', '2'].includes(portType)
      this.isMotivate = place_attribute === '11' /* eslint-disable-line */
      // eslint-disable-next-line camelcase
      this.isOpenScreen = place_attribute === '1' // 是否是开屏广告
      await this.getMaterialSizes(value) // 获取素材尺寸
      // 更新素材状态，处理 filenames
      this.form.filenames.splice(0)
    },
    async checkAdUrl() {
      const { conversion_monitor_type: type, ad_url: url } = this.form
      this.adUrlTxt = ''
      this.checking = true
      const [err, res] = await this['creation/checkAdUrl']({ platform: this.platform, type, url })
      this.adUrlTxt = res.msg
      this.checking = false
      if (err || res.code !== 1) { // 验证失败
        this.validAdUrl = false
      } else { // 成功
        this.validAdUrl = true
        this.isAdUrlPicExist = res.data && res.data.status === 1
      }
      this.lastAdUrl = url // 上一个 url
      return this.validAdUrl
    },
    // 更新跳转行为
    handleChangeJumpType() {
      if (['add'].includes(this.type)) {
        const openScreenMsg = {
          1: '点击跳转详情页或第三方应用',
          2: '点击下载或跳转第三方应用',
          3: '点击跳转详情页或第三方应用'
        }
        this.form.open_screen_guide_text = openScreenMsg[this.currentGroupJumpType]
      }
    },
    handleAdUrlChange() {
      this.form.ad_url = this.form.ad_url.replace(/\s+/g, '') // 移除空格
    },
    openAdUrl() {
      window.open(this.form.ad_url, '_tab')
    },
    async uploadPicture(file, isMaterial) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('information', this.form.information || '0')
      return await this['creation/uploadPicture']({ platform: this.platform, isMaterial, formData })
    },
    async uploadMaterialCut(file, size) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('cut_size', size)
      return await this['creation/uploadMaterialCut']({ platform: this.platform, formData })
    },
    async uploadVideo(file, ratioId) {
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('ratio_id', ratioId)
      return await this['creation/uploadVideo']({ platform: this.platform, formData })
    },
    beforeUploadAdUrl(file) {
      const isSupport = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.raw.type);
      const isLt150KB = file.raw.size / 1024 < 150;

      if (!isSupport) {
        this.$message.error('落地页长截图只能是 png, jpg, jpeg 格式！');
      }
      if (!isLt150KB) {
        this.$message.error('落地页长截图大小不能超过 150KB！');
      }
      return isSupport && isLt150KB
    },
    async handleOnChangeAdUrl(file, fileList) {
      if (!this.beforeUploadAdUrl(file)) return

      const [err, res] = await this.uploadPicture(file)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '上传落地页长截图失败！')
      else {
        this.fileList.splice(0, this.fileList.length, file)
        const { path } = res.data
        this.form.landing_page_pic = path
      }
    },
    async getMaterialSizes(adId) { // 获取素材尺寸
      const [err, res] = await this['creation/getMaterialSizes']({ platform: this.platform, id: this.form.ad_id || adId })
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取素材尺寸失败！')
      else {
        this.page.setData({
          data: res.data.map((item, index) => ({
            ...item,
            cut_path: '', // 裁切路径
            cut_size: '', // 裁切尺寸
            no: index + 1, // 编号
            material: '',
            material_size: ''
          }))
        })

        const length = this.page.data.length
        this.uploading = Array.from({ length }, Boolean)
        this.visibles = Array.from({ length }, Boolean)
        this.removing = Array.from({ length }, Boolean)
      }
    },
    beforeUploadPictureMaterial(file, replace, materialType) {
      // 数量校验
      if (this.isMotivate && !replace) { // materialType
        const groupedMtData = groupBy(this.page.data, 'material_type')
        if (materialType === 1 && groupedMtData[1] && groupedMtData[1].filter(item => item.material).length > 0) { // 不是替换并且已经上传过主素材了
          this.$message.error('只能上传一个主素材图片，如需上传，请删除之前上传的主素材')
          return false
        }

        if (materialType === 2 && groupedMtData[2] && groupedMtData[2].filter(item => item.material).length > 0) { // 不是替换并且已经上传过封面了
          this.$message.error('只能上传一个封面图片，如需上传，请删除之前上传的封面')
          return false
        }

        if (materialType === 3 && groupedMtData[3] && groupedMtData[3].filter(item => item.material).length > 0) { // 不是替换并且已经上传过icon了
          this.$message.error('只能上传一个icon图片，如需上传，请删除之前上传的icon')
          return false
        }
      }

      const isSupport = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'].includes(file.raw.type)
      const isLt150KB = file.raw.size / 1024 < 150;
      if (!isSupport) {
        this.$message.error('素材图片只能是 png, jpg, jpeg, gif 格式！');
      }
      if (!isLt150KB) {
        this.$message.error('素材图片大小不能超过 150KB！');
      }
      return isSupport && isLt150KB
    },
    beforeUploadVideoMaterail(file, replace) {
      // 数量校验
      const groupedData = groupBy(this.page.data, 'create_type')
      if (!replace && groupedData[2] && groupedData[2].filter(item => item.material).length > 0) { // 不是替换并且已经上传过视频了
        this.$message.error('只能上传一个素材视频，如需上传，请删除之前上传的视频')
        return false
      }

      const isSupport = ['video/mp4'].includes(file.raw.type);
      const isLt50M = file.raw.size / 1024 / 1024 < 50;

      if (!isSupport) {
        this.$message.error('素材视频只能是 mp4 格式！');
      }

      if (!isLt50M) {
        this.$message.error('素材视频大小不能超过 50MB！');
      }

      return isSupport && isLt50M;
    },
    async handleOnRemove({ row, $index }) {
      if (row.id) { // 已保存到数据库的素材
        if (this.removing[$index]) return
        this.removing.splice($index, 1, true)
        const [err, res] = await this['creation/handleOnRemove']({ platform: this.platform, ids: row.id })
        this.removing.splice($index, 1, false)
        if (err || res.code !== 1) return this.$message.error((err || res).msg || '删除素材失败！')
      }

      this.visibles.splice($index, 1, false)
      // 重置
      this.page.data = this.page.data.map(item => {
        if (item.no === row.no) {
          return {
            ...item,
            cut_path: '', // 裁切路径
            cut_size: '', // 裁切尺寸
            material: '',
            material_size: ''
          }
        }
        return item
      })
      this.form.filenames = this.form.filenames.filter(item => item.no !== row.no)
      this.$message.success('删除素材成功！')
    },
    handleCellClick(row, column) {
      if (column.property === 'material' && row.material) {
        this.preview.data = this.page.data.filter(item => item.material)
        this.preview.activeIndex = this.page.data.indexOf(row)
        this.preview.visible = true
      }
    },
    isMatchVideo(size) {
      size = this.page.data.filter(v => v.create_type === 2)
        .find(v => v.size === size || v.minimum_upload_size === size)
      return [!!size, size]
    },
    /**
     * 上传素材
     */
    async handleOnChange(file, fileList, scope) {
      // 是否选择了素材类型
      if (!this.form.create_type) {
        this.$message.error('请先选择素材类型！')
        return this.$refs.form.validateField('create_type')
      }
      // 校验素材类型
      if (this.isMotivate) { // 激励视频
        if (scope.row.create_type === 1 && !this.beforeUploadPictureMaterial(file, !!scope.row.material, scope.row.material_type)) return
        if (scope.row.create_type === 2 && !this.beforeUploadVideoMaterail(file, !!scope.row.material)) return
      } else {
        if (this.form.create_type === '1' && !this.beforeUploadPictureMaterial(file)) return
      }

      // 是否正在上传
      if (this.uploading[scope.$index]) return
      this.uploading.splice(scope.$index, 1, true)

      // 上传
      let err, res
      if (this.isMotivate) {
        if (scope.row.create_type === 2) {
          [err, res] = await this.uploadVideo(file, scope.row.ratio_id)
        } else {
          [err, res] = await this.uploadMaterialCut(file, scope.row.ratio_id)
        }
      } else {
        [err, res] = await this.uploadMaterialCut(file, scope.row.minimum_upload_size)
      }

      this.uploading.splice(scope.$index, 1, false)
      if (err || res.code !== 1) this.$message.error((err || res).msg || '上传素材失败！')
      else {
        const { path, size, seconds, file_size: fileSize, cut_path: cutPath, cut_size: cutSize } = res.data

        if (scope.row.create_type === 2) { // 视频
          const [matched] = this.isMatchVideo(size)
          if (!matched) {
            this.$message.error('素材视频尺寸不匹配，请重新上传')
            return
          }
        }

        this.page.setData({
          data: this.page.data.map((item, index) => {
            if (scope.$index === index) {
              return {
                ...item,
                cut_path: cutPath,
                cut_size: cutSize,
                material: path,
                material_size: size,
                create_type: scope.row.create_type,
                material_type: scope.row.material_type
              }
            }
            return item
          })
        })

        if (scope.row.material) { // 替换
          this.form.filenames = this.form.filenames.map(item => {
            if (item.no === scope.row.no) {
              return ({
                ...item,
                path,
                size,
                seconds,
                file_size: fileSize,
                cut_path: cutPath
              })
            }
            return item
          })
        } else { // 上传
          this.form.filenames.push({
            path,
            size,
            cut_path: cutPath,
            ratio_id: scope.row.ratio_id,
            create_type: scope.row.create_type,
            material_type: scope.row.material_type,
            seconds,
            file_size: fileSize,
            no: scope.row.no
          })
        }
        this.$refs.form.validateField('filenames')
      }
    },
    // 第三方检测
    handleAddMonitor(type) {
      this.form[type].push({
        value: '',
        key: Date.now()
      })
    },
    handleRemoveMonitor(item, type) {
      let index = this.form[type].indexOf(item)
      if (index !== -1) {
        this.form[type].splice(index, 1)
      }
    },
    filterMonitor(data, type) {
      return this.form[type].filter(item => item.value !== '').map(item => item.value).join(',')
    },
    getMonitor(data, type) {
      const arr = data.split(',')
      const newArr = []
      arr.forEach(item => {
        newArr.push({
          key: Date.now(),
          value: item
        })
      })
      return newArr
    },
    submitForm(formName) {
      if (this.verifying) return
      this.verifying = true
      if (this.submited || this.submiting) return this.$message.error('请勿重复提交数据！')
      this.$refs[formName].validate(async (valid, errors) => {
        if (valid) { /* eslint-disable camelcase */
          this.submiting = true
          this.verifying = false

          const text = this.type === 'edit' ? '修改' : this.type === 'copy' ? '复制' : '添加'
          const { aduser_id: adUserId, information, open_screen_guide_text, title, spread_name, monitor_pv_urls, monitor_urls, ...formData } = this.form

          // if (this.isFlow || this.isMotivate) {
          //   formData.information = information
          //   formData.title = title
          //   formData.spread_name = spread_name
          // }

          formData.information = information
          formData.title = title
          formData.spread_name = spread_name
          formData.open_screen_guide_text = this.isOpenScreen ? open_screen_guide_text : ''

          formData.filenames = formData.filenames.map(({ no, ...rest }) => rest)
          formData.monitor_pv_urls = this.filterMonitor(monitor_pv_urls, 'monitor_pv_urls')
          formData.monitor_urls = this.filterMonitor(monitor_urls, 'monitor_urls')
          const [err, res] = await this['creation/submitForm']({ platform: this.platform, type: this.type, id: this.id, formData })
          this.submiting = false
          if (err || res.code !== 1) return this.$message.error((err || res).msg || `${text}创意失败！`)
          else {
            this.submited = true
            this.$message.success(`${text}创意成功！`)
            setTimeout(_ => this.$router.push('/creations'), 2000)
          }
        } else {
          // this.$message.error('请填写完整信息！')
          this.$message.error({
            message: h('div', { class: 'el-message__content' }, [
              h('p', {}, '请填写完整信息！'),
              h('br'),
              h('ol', { style: { 'list-style-type': 'decimal', 'padding-left': '15px' } }, Object.keys(errors).map(key => h('li', {}, errors[key][0].message)))
            ])
          })
          this.verifying = false
          return false
        }
      })
    }
  },
  async created() {
    const { id, type } = this.$route.params
    this.platform = this.$route.meta.platform
    this.id = id
    this.type = type
    this.loading = true

    const items = new Map()
      .set('conversion_monitor_type', 'conversionMonitorTypes')
      .set('monitor_type', 'monitorTypes')
    // .set('create_type', 'createTypes')
    // .set('information', 'informations')
    const itemValues = [...items.values()]
    this['creation/getItems']({ keys: items.keys() })
      .then(results => {
        results.forEach((res, i) => {
          this[itemValues[i]] = res.data
        })

        if (!this.id) this.loading = false
      })

    // 获取广告主下拉菜单
    if (this.platform === 'agency') this.getAdUsers()
    else if (this.platform === 'ad-user') await this.getAdGroupsByAdUserId()

    // 获取创意
    if (this.id) {
      const [err, res] = await this['creation/created']({ platform: this.platform, id: this.id })
      if (err || res.code !== 1) this.$message.error((err || res).msg || '获取创意信息失败！')
      else { /* eslint-disable camelcase */
        const {
          advertiser_id: advertiserId,
          order_id: orderId,
          ad_id: adId,
          creative_name: creationName,
          conversion_monitor_type,
          ad_url,
          landing_page_pic,
          apk_name,
          first_app_store,
          deeplink,
          monitor_type,
          monitor_pv_urls,
          monitor_urls,
          create_type,
          title,
          spread_name,
          materials,
          open_screen_guide_text
        } = res.data
        this.originalCreativeName = creationName
        if (this.platform === 'agency') {
          await this.getAdGroupsByAdUserId(advertiserId, true)
        }
        await this.getPlansByAdGroupId(orderId, true)
        await this.handleAdPlanChange(adId)

        if (this.form.information === '2') { // 组图
          this.page.setData({
            data: this.page.data.map((item, index) => {
              const material = materials[index]
              if (material) {
                return {
                  ...item,
                  id: this.type !== 'copy' ? material.id : undefined,
                  cut_path: material.cut_path || material.path,
                  cut_size: item.minimum_upload_size,
                  material: material.path,
                  material_size: material.size
                }
              }
              return item
            })
            // data: materials.map((material, index) => {
            //   const item = this.page.data.find(item => String(item.ratio_id) === material.ratio_id) || {}
            //   return {
            //     ...item,
            //     id: this.type !== 'copy' ? material.id : undefined,
            //     cut_path: material.cut_path,
            //     cut_size: item.minimum_upload_size,
            //     material: material.path,
            //     material_size: material.size,
            //     no: index + 1
            //   }
            // })
          })
        } else {
          this.page.setData({
            data: this.page.data.map(item => {
              // const material = materials.find(material => String(item.ratio_id) === String(material.ratio_id) || item.minimum_upload_size === material.size)
              const material = materials.find(material => String(item.ratio_id) === String(material.ratio_id))

              if (material) {
                return {
                  ...item,
                  id: this.type !== 'copy' ? material.id : undefined,
                  cut_path: material.cut_path || material.path,
                  cut_size: item.minimum_upload_size,
                  material: material.path,
                  material_size: material.size
                }
              }
              return item
            })
          })

          const defaultSizes = this.page.data.map(item => item.minimum_upload_size)
          const ratioIds = this.page.data.map(item => String(item.ratio_id))
          materials.forEach(item => {
            if (!defaultSizes.includes(item.size) && !ratioIds.includes(item.ratio_id)) {
              this.page.data.push({
                ...item,
                no: this.page.data.length + 1,
                cut_path: item.path,
                cut_size: item.size,
                material: item.path,
                material_size: item.size,
                minimum_upload_size: item.size
              })
            }
          })
        }

        this.form = Object.assign({}, this.form, {
          aduser_id: advertiserId,
          order_id: orderId,
          ad_id: adId,
          creative_name: creationName, // this.type !== 'copy' ? creationName : `${creationName}_${+new Date()}`,
          conversion_monitor_type,
          ad_url,
          landing_page_pic,
          apk_name,
          first_app_store: parseInt(first_app_store),
          deeplink,
          monitor_type,
          monitor_pv_urls: this.getMonitor(monitor_pv_urls, 'monitor_pv_urls'),
          monitor_urls: this.getMonitor(monitor_urls, 'monitor_urls'),
          create_type,
          title,
          spread_name,
          open_screen_guide_text,
          filenames: this.page.data.reduce((acc, item, index) => {
            if (item.material) {
              acc.push({
                id: this.type !== 'copy' ? item.id : undefined,
                path: item.material,
                size: item.material_size,
                cut_path: item.cut_path || item.material,
                ratio_id: item.ratio_id,
                no: item.no,
                seconds: item.seconds,
                file_size: item.file_size,
                create_type: item.create_type,
                material_type: item.material_type
              })
            }
            return acc
          }, [])
        })

        // this.currentGroup = this.adGroups.find(v => v.id === orderId) || {}
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
@include b(adput-creation-add) {
  @include e(preview) {
    .el-carousel__container {
      height: 420px;
    }
  }

  @include e(preview-image-wrap) {
    background: white;
    height: 100%;
  }

  @include e(preview-image) {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }

  .icon-iconfontquestion {
    color: #fc8675;
  }

  @include e(landpage) {
    position: relative;

    .icon-iconfontquestion {
      color: #fc8675;
    }
  }

  @include e(landpage-message) {
    @include is(correct) {
      color: #66cfa7;
    }
    @include is(wrong) {
      color: #fc8675;
    }
  }

  @include e(landpage-upload) {
    .el-upload {
      margin-left: 16px;
    }

    // .el-upload-list {
    //   .el-upload-list__item {
    //     padding: 0;
    //     max-width: 364px;
    //     max-height: 200px;
    //     height: auto;
    //   }
    //   .el-upload-list__item-thumbnail {
    //     width: 100%;
    //     max-height: 200px;
    //     height: auto;
    //     margin-left: 0;
    //   }
    //   .el-icon-close {
    //     display: none;
    //     z-index: 99;
    //     font-size: 24px;
    //   }
    //   .el-upload-list__item-name {
    //     display: none;
    //   }
    // }
  }

  @include e(landpage-tip) {
    position: absolute;
    top: 0;
    left: 170px;
  }

  @include e(landpage-pic) {
    margin-left: 16px;
    max-width: 364px;
    max-height: 200px;

    img {
      max-width: 100%;
      max-height: 200px;
      height: auto;
    }
  }

  @include e(table-material) {
    display: block;
    width: 100%;
    height: auto;
  }

  @include e(table-material-size) {
    text-align: left;

    span {
      @include is(recommend) {
        color: #e21d25;
      }
    }
  }

  @include e(table-remark) {
    font-size: 12px;
    color: #999;
  }

  @include e(material-size) {
    span {
      color: #999;

      &:last-child {
        margin-left: 20px;
      }
    }
  }

  @include e(upload-tip) {
    margin-left: 16px;
    font-size: 12px;
    color: #fc8675;
  }

  @include e(table) {
    margin-top: 16px;
    margin-left: 16px;

    .icon-right {
      color: #66cfa7;
    }

    .icon-wrong {
      color: #fc8675;
    }

    .is-path {
      text-decoration: underline;
      color: #1c8de0;
    }

    .is-preview {
      max-width: 100%;
      max-height: 100px;
      margin: 0 auto;
    }
  }

  @include e(replace) {
    display: inline-block;
  }
  @include e(monitor) {
    margin-bottom: 0;
    &>.el-form-item__content{
      display: flex;
      flex-direction: column;
    }
    .el-form-item{
      margin-bottom: 22px;
    }
  }
}
</style>
